const actions = {
  CLEAR_OBJECTIVE_ACTIVITIES: 'CLEAR_OBJECTIVE_ACTIVITIES',
  FETCH_OBJECTIVE_DETAILS: 'FETCH_OBJECTIVE_DETAILS',
  FETCH_OBJECTIVE_ACTIVITIES: 'FETCH_OBJECTIVE_ACTIVITIES',
  FETCH_OBJECTIVE_COMMENTS: 'FETCH_OBJECTIVE_COMMENTS',
  FETCH_OBJECTIVE_CHECKINS: 'FETCH_OBJECTIVE_CHECKINS',
  SAVE_OBJECTIVE_ACTIVITIES: 'SAVE_OBJECTIVE_ACTIVITIES',
  SAVE_OBJECTIVE_COMMENTS: 'SAVE_OBJECTIVE_COMMENTS',
  SAVE_OBJECTIVE_CHECKINS: 'SAVE_OBJECTIVE_CHECKINS',
  UPDATE_OBJECTIVE_DETAILS: 'UPDATE_OBJECTIVE_DETAILS',
  UPDATE_OBJECTIVE_CYCLE: 'UPDATE_OBJECTIVE_CYCLE',
  POST_OBJECTIVE_COMMENT: 'POST_OBJECTIVE_COMMENT',
  UPDATE_OBJECTIVE_COMMENT: 'UPDATE_OBJECTIVE_COMMENT',
  UPDATE_OBJECTIVE_TYPE: 'UPDATE_OBJECTIVE_TYPE',
  DELETE_OBJECTIVE_COMMENT: 'DELETE_OBJECTIVE_COMMENT',
  CREATE_OBJECTIVE_DUPLICATE: 'CREATE_OBJECTIVE_DUPLICATE',
  UPDATE_OBJECTIVE_METRICS: 'UPDATE_OBJECTIVE_METRICS',
  ADD_OBJECTIVE_METRICS: 'ADD_OBJECTIVE_METRICS',
  GET_METRIC_DASHBOARD: 'GET_METRIC_DASHBOARD',
  SAVE_METRIC_DASHBOARD_INFO: 'SAVE_METRIC_DASHBOARD_INFO',
  DELETE_METRIC: 'DELETE_METRIC',
  SAVE_FOCUS_COMMENT_ID_ACTION: 'SAVE_FOCUS_COMMENT_ID_ACTION',
  UPDATE_ACTIVITY_REALTIME_EVENT: 'UPDATE_ACTIVITY_REALTIME_EVENT',
  UPDATE_COMMENTS_REALTIME_EVENT: 'UPDATE_COMMENTS_REALTIME_EVENT',
  UPDATE_CHECKINS_REALTIME_EVENT: 'UPDATE_CHECKINS_REALTIME_EVENT',
  CHECK_IF_OBJECTIVE_DUPLICATE_EXISTS: 'CHECK_IF_OBJECTIVE_DUPLICATE_EXISTS',
  FETCH_JIRA_CONNECTIONS: 'FETCH_JIRA_CONNECTIONS',
  FETCH_JIRA_ISSUES: 'FETCH_JIRA_ISSUES',
  FETCH_JIRA_LABELS: 'FETCH_JIRA_LABELS',
  SAVE_JIRA_CONNECTIONS: 'SAVE_JIRA_CONNECTIONS',
  SAVE_USER_JIRA_CONNECTIONS: 'SAVE_USER_JIRA_CONNECTIONS',
  SAVE_NON_USER_JIRA_CONNECTIONS: 'SAVE_NON_USER_JIRA_CONNECTIONS',
  SAVE_JIRA_ISSUES: 'SAVE_JIRA_ISSUES',
  SAVE_JIRA_LABELS: 'SAVE_JIRA_LABELS',
  CREATE_JIRA_CONNECTION: 'CREATE_JIRA_CONNECTION',
  SAVE_CREATE_CONNECTION_REQUEST_STATUS:
    'SAVE_CREATE_CONNECTION_REQUEST_STATUS',
  RESET_CREATE_CONNECTION_REQUEST_STATUS:
    'RESET_CREATE_CONNECTION_REQUEST_STATUS',
  SAVE_ISSUES_REQUEST_STATUS: 'SAVE_ISSUES_REQUEST_STATUS',
  RESET_ISSUES_REQUEST_STATUS: 'RESET_ISSUES_REQUEST_STATUS',
  CONNECTIONS_REQUEST_STATUS: 'CONNECTIONS_REQUEST_STATUS',
  TRACK_PROGRESS_WITH_JIRA: 'TRACK_PROGRESS_WITH_JIRA',
  TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS:
    'TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS',
  RESET_TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS:
    'RESET_TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS',
  TRIGGER_MANUAL_JIRA_PROGRESS_UPDATE: 'TRIGGER_MANUAL_JIRA_PROGRESS_UPDATE',
  UPDATE_JIRA_CONNECTION: 'UPDATE_JIRA_CONNECTION',
  DELETE_JIRA_CONNECTION: 'DELETE_JIRA_CONNECTION',
  DELETE_JIRA_PROGRESS_TRACKER: 'DELETE_JIRA_PROGRESS_TRACKER',
  DELETE_PROGRESS_TRACKER_REQUEST_STATUS:
    'DELETE_PROGRESS_TRACKER_REQUEST_STATUS',
  GET_JIRA_INTEGRATION_LATEST_PROGRESS: 'GET_JIRA_INTEGRATION_LATEST_PROGRESS',
  SAVE_JIRA_INTEGRATION_LATEST_PROGRESS:
    'SAVE_JIRA_INTEGRATION_LATEST_PROGRESS',
  GET_OBJECTIVE_DETAILS: 'GET_OBJECTIVE_DETAILS',
  SAVE_OBJECTIVE_DETAILS: 'SAVE_OBJECTIVE_DETAILS',
  ADD_REACTION: 'ADD_REACTION',
  REMOVE_REACTION: 'REMOVE_REACTION',
  SAVE_ADD_REACTION: 'SAVE_ADD_REACTION',
  SAVE_REMOVE_REACTION: 'SAVE_REMOVE_REACTION',
  SAVE_RECENT_REACTION_ASSOCIATION_ID: 'SAVE_RECENT_REACTION_ASSOCIATION_ID',
  VIEW_IN_CONTEXT_REQUEST: 'VIEW_IN_CONTEXT_REQUEST',
  INITIATE_VIEW_IN_CONTEXT_REQUEST_FROM_PARAM:
    'INITIATE_VIEW_IN_CONTEXT_REQUEST_FROM_PARAM',
  SAVE_VIEW_IN_CONTEXT_DATA: 'SAVE_VIEW_IN_CONTEXT_DATA',
  SAVE_OBJECTIVE_ACTIVITY_DETAILS: 'SAVE_OBJECTIVE_ACTIVITY_DETAILS',
  FETCH_DETAILS_PAGE_DATA: 'FETCH_DETAILS_PAGE_DATA',
  SAVE_DETAILS_PAGE_DATA: 'SAVE_DETAILS_PAGE_DATA',
  SAVE_DETAILS_PAGE_DATA_SET1:
    'SAVE_DETAILS_PAGE_DATA_SET1' /* check-ins and graph data */,
  SAVE_DETAILS_PAGE_DATA_SET2:
    'SAVE_DETAILS_PAGE_DATA_SET2' /* objective activity and comments data */,
  STRATEGIC_GOALS_VIEW_IN_CONTEXT_REQUEST:
    'STRATEGIC_GOALS_VIEW_IN_CONTEXT_REQUEST',
  ACKNOWLEDGE_AUTO_ROLL_UP_KR_CHANGE: 'ACKNOWLEDGE_AUTO_ROLL_UP_KR_CHANGE',
  TRIGGER_MANUAL_JIRA_PROGRESS_UPDATE_FOR_CHECK_IN_MODAL:
    'TRIGGER_MANUAL_JIRA_PROGRESS_UPDATE_FOR_CHECK_IN_MODAL'
};
export default actions;

export const updateObjectiveDetails = (
  objective,
  requestBody,
  updateSelectedObjective,
  updateObjDetails = false
) => ({
  type: actions.UPDATE_OBJECTIVE_DETAILS,
  objective,
  requestBody,
  updateSelectedObjective,
  updateObjDetails
});

export const createObjectiveDuplicate = (
  objective,
  requestBody,
  updateSelectedObjective
) => ({
  type: actions.CREATE_OBJECTIVE_DUPLICATE,
  objective,
  requestBody,
  updateSelectedObjective
});

export const checkIfObjectiveDuplicateExistsAction = (
  objective,
  requestBody,
  callback
) => ({
  type: actions.CHECK_IF_OBJECTIVE_DUPLICATE_EXISTS,
  objective,
  requestBody,
  callback
});

export const updateObjectiveType = (
  objective,
  requestBody,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_OBJECTIVE_TYPE,
  objective,
  requestBody,
  updateSelectedObjective
});

export const fetchObjectiveDetails = objectiveId => ({
  type: actions.FETCH_OBJECTIVE_DETAILS,
  objectiveId
});

// only the activities
export const fetchObjectiveActivities = objectiveId => ({
  type: actions.FETCH_OBJECTIVE_ACTIVITIES,
  objectiveId
});

// only the comments
export const fetchObjectiveComments = (objectiveId, callback = null) => ({
  type: actions.FETCH_OBJECTIVE_COMMENTS,
  objectiveId,
  callback
});

// only the checkins
export const fetchObjectiveCheckIns = objectiveId => ({
  type: actions.FETCH_OBJECTIVE_CHECKINS,
  objectiveId
});

export const clearObjectiveActivities = () => ({
  type: actions.CLEAR_OBJECTIVE_ACTIVITIES
});

export const saveObjectiveActivities = responseData => ({
  type: actions.SAVE_OBJECTIVE_ACTIVITIES,
  responseData
});

export const saveObjectiveComments = responseData => ({
  type: actions.SAVE_OBJECTIVE_COMMENTS,
  responseData
});

export const saveObjectiveCheckins = responseData => ({
  type: actions.SAVE_OBJECTIVE_CHECKINS,
  responseData
});

export const updateObjectiveCycle = (
  objective,
  requestBody,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_OBJECTIVE_CYCLE,
  objective,
  requestBody,
  updateSelectedObjective
});

export const postObjectiveComment = (objective_id, requestBody, callback) => ({
  type: actions.POST_OBJECTIVE_COMMENT,
  objective_id,
  requestBody,
  callback
});

export const updateObjectiveComment = (
  objective_id,
  checkInId,
  requestBody,
  commentRow,
  callback
) => ({
  type: actions.UPDATE_OBJECTIVE_COMMENT,
  objective_id,
  checkInId,
  requestBody,
  commentRow,
  callback
});

export const deleteObjectiveComment = (
  objective_id,
  id,
  activityType,
  task_model,
  cb
) => ({
  type: actions.DELETE_OBJECTIVE_COMMENT,
  objective_id,
  id,
  activityType,
  task_model,
  cb
});

export const updateObjectiveMetrics = (
  objective,
  requestBody,
  updateSelectedObjective
) => ({
  type: actions.UPDATE_OBJECTIVE_METRICS,
  objective,
  requestBody,
  updateSelectedObjective
});

export const addObjectiveMetrics = (
  objective,
  requestBody,
  updateSelectedObjective
) => ({
  type: actions.ADD_OBJECTIVE_METRICS,
  objective,
  requestBody,
  updateSelectedObjective
});

export const getMetricDashboard = (objective_id, callback) => ({
  type: actions.GET_METRIC_DASHBOARD,
  objective_id,
  callback
});

export const saveMetricDashboardInfo = data => ({
  type: actions.SAVE_METRIC_DASHBOARD_INFO,
  data
});

export const deleteMetricAction = (objective, updateSelectedObjective) => ({
  type: actions.DELETE_METRIC,
  objective,
  updateSelectedObjective
});

export const saveInFocusCommentId = comment_id => ({
  type: actions.SAVE_FOCUS_COMMENT_ID_ACTION,
  comment_id
});

export const triggerActivityRealtimeUpdate = objective_id => ({
  type: actions.UPDATE_ACTIVITY_REALTIME_EVENT,
  objective_id
});

export const triggerCommentsRealtimeUpdate = objective_id => ({
  type: actions.UPDATE_COMMENTS_REALTIME_EVENT,
  objective_id
});

export const triggerCheckinsRealtimeUpdate = objective_id => ({
  type: actions.UPDATE_CHECKINS_REALTIME_EVENT,
  objective_id
});

export const fetchJiraConnections = user_reference_id => ({
  type: actions.FETCH_JIRA_CONNECTIONS,
  user_reference_id
});

export const fetchJiraIssues = (jira_id, query) => ({
  type: actions.FETCH_JIRA_ISSUES,
  jira_id,
  query
});

export const fetchJiraLabels = jira_id => ({
  type: actions.FETCH_JIRA_LABELS,
  jira_id
});

export const saveJiraConnections = data => ({
  type: actions.SAVE_JIRA_CONNECTIONS,
  data
});

export const saveUserJiraConnections = data => ({
  type: actions.SAVE_USER_JIRA_CONNECTIONS,
  data
});

export const saveNonUserJiraConnections = data => ({
  type: actions.SAVE_NON_USER_JIRA_CONNECTIONS,
  data
});

export const saveJiraIssues = data => ({
  type: actions.SAVE_JIRA_ISSUES,
  data
});

export const saveJiraLabels = data => ({
  type: actions.SAVE_JIRA_LABELS,
  data
});

export const createJiraConnection = requestBody => ({
  type: actions.CREATE_JIRA_CONNECTION,
  requestBody
});

export const saveCreateConnectionRequestStatus = status => ({
  type: actions.SAVE_CREATE_CONNECTION_REQUEST_STATUS,
  status
});

export const resetCreateConnectionRequestStatus = () => ({
  type: actions.RESET_CREATE_CONNECTION_REQUEST_STATUS
});

export const saveQueryIssuesRequestStatus = status => ({
  type: actions.SAVE_ISSUES_REQUEST_STATUS,
  status
});

export const resetQueryIssuesRequestStatus = () => ({
  type: actions.RESET_ISSUES_REQUEST_STATUS
});

export const saveConnectionRequestStatus = status => ({
  type: actions.CONNECTIONS_REQUEST_STATUS,
  status
});

export const trackProgressWithJira = (requestBody, jiraId, update = false) => ({
  type: actions.TRACK_PROGRESS_WITH_JIRA,
  requestBody,
  jiraId,
  update
});

export const saveTrackProgressRequestStatus = status => ({
  type: actions.TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS,
  status
});

export const resetTrackProgressRequestStatus = () => ({
  type: actions.RESET_TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS
});

export const triggerManualJiraProgressUpdate = (objective_id, version) => ({
  type: actions.TRIGGER_MANUAL_JIRA_PROGRESS_UPDATE,
  objective_id,
  version
});

export const updateJiraConnection = (jiraId, connection_name) => ({
  type: actions.UPDATE_JIRA_CONNECTION,
  jiraId,
  connection_name
});

export const deleteJiraConnection = jiraId => ({
  type: actions.DELETE_JIRA_CONNECTION,
  jiraId
});

export const deleteJiraProgressTracker = requestBody => ({
  type: actions.DELETE_JIRA_PROGRESS_TRACKER,
  requestBody
});

export const saveDeleteProgressTrackerRequestStatus = status => ({
  type: actions.DELETE_PROGRESS_TRACKER_REQUEST_STATUS,
  status
});

export const getJiraIntegrationLatestProgress = requestBody => ({
  type: actions.GET_JIRA_INTEGRATION_LATEST_PROGRESS,
  requestBody
});

export const saveJiraIntegrationLatestProgress = data => ({
  type: actions.SAVE_JIRA_INTEGRATION_LATEST_PROGRESS,
  data
});

export const getObjectiveDetailsForJiraIntegration = objective_id => ({
  type: actions.GET_OBJECTIVE_DETAILS,
  objective_id
});

export const saveObjectiveDetailsForJiraIntegration = data => ({
  type: actions.SAVE_OBJECTIVE_DETAILS,
  data
});

export const addReaction = data => ({
  type: actions.ADD_REACTION,
  data
});

export const removeReaction = data => ({
  type: actions.REMOVE_REACTION,
  data
});

export const saveAddReaction = data => ({
  type: actions.SAVE_ADD_REACTION,
  data
});

export const saveRemoveReaction = data => ({
  type: actions.SAVE_REMOVE_REACTION,
  data
});

export const saveRecentReactionAssociationId = association_id => ({
  type: actions.SAVE_RECENT_REACTION_ASSOCIATION_ID,
  association_id
});

export const viewInContextRequest = (objective, isLinkedObjective) => ({
  type: actions.VIEW_IN_CONTEXT_REQUEST,
  objective,
  isLinkedObjective
});

export const initiateViewInContextRequestFromQueryParam = objective_id => ({
  type: actions.INITIATE_VIEW_IN_CONTEXT_REQUEST_FROM_PARAM,
  objective_id
});

export const saveViewInContextObjectiveData = (
  objective,
  selectedCycle,
  selectedTab
) => ({
  type: actions.SAVE_VIEW_IN_CONTEXT_DATA,
  objective,
  selectedCycle,
  selectedTab
});

export const saveObjectiveActivityDetails = (
  activity_details,
  comment_details,
  check_in_details
) => ({
  type: actions.SAVE_OBJECTIVE_ACTIVITY_DETAILS,
  activity_details,
  comment_details,
  check_in_details
});

export const fetchDetailsPageData = objectiveId => ({
  type: actions.FETCH_DETAILS_PAGE_DATA,
  objectiveId
});

export const saveDetailsPageData = (
  metricDashboardData,
  checkInDetails,
  activityDetails,
  commentDetails
) => ({
  type: actions.SAVE_DETAILS_PAGE_DATA,
  metricDashboardData,
  checkInDetails,
  activityDetails,
  commentDetails
});

export const saveDetailsPageSet1Data = (
  metricDashboardData,
  checkInDetails
) => ({
  type: actions.SAVE_DETAILS_PAGE_DATA_SET1,
  metricDashboardData,
  checkInDetails
});

export const saveDetailsPageSet2Data = (activityDetails, commentDetails) => ({
  type: actions.SAVE_DETAILS_PAGE_DATA_SET2,
  activityDetails,
  commentDetails
});

export const strategicGoalsViewInContextRequest = (
  objective,
  isLinkedObjective,
  isContinuation = false
) => ({
  type: actions.STRATEGIC_GOALS_VIEW_IN_CONTEXT_REQUEST,
  objective,
  isLinkedObjective,
  isContinuation
});

export const acknowledgeAutoRollUpKRChange = (objective, callback) => ({
  type: actions.ACKNOWLEDGE_AUTO_ROLL_UP_KR_CHANGE,
  objective,
  callback
});

export const triggerManualJiraProgressUpdateForCheckInModal = (
  objective_id,
  version,
  callback
) => ({
  type: actions.TRIGGER_MANUAL_JIRA_PROGRESS_UPDATE_FOR_CHECK_IN_MODAL,
  objective_id,
  version,
  callback
});
